export const LoaderView = () => {
  return <h1>Loading</h1>;
};
